import { useCallback, useEffect, useState } from 'react';
import { API_BASE } from './config';
import PlayerSearchDropdown from './PlayerSearchDropdown';
import '../css/LockedPairsModal.css';

function LockedPairsModal({ groupId, onClose }) {
  const [pairs, setPairs] = useState([]);
  const [players, setPlayers] = useState([]);
  const [playerA, setPlayerA] = useState(null);
  const [playerB, setPlayerB] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const request = useCallback(async (path, options = {}) => {
    const response = await fetch(`${API_BASE}${path}`, { ...options, headers: { 'Content-Type': 'application/json', ...(options.headers || {}) } });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.message || `HTTP ${response.status}`);
    return data;
  }, []);
  const load = useCallback(async () => {
    try {
      const [lockedPairs, groupPlayers] = await Promise.all([request(`/api/game-match/locked-pairs/${Number(groupId)}`), request(`/api/game-match/group/${Number(groupId)}/players`)]);
      setPairs(Array.isArray(lockedPairs) ? lockedPairs : []);
      setPlayers(Array.isArray(groupPlayers) ? groupPlayers : []);
      setError('');
    } catch (loadError) { setError(loadError.message); }
  }, [groupId, request]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    const closeOnEscape = event => { if (event.key === 'Escape') onClose(); };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [onClose]);

  const lockPair = async () => {
    if (!playerA || !playerB || busy) return;
    setBusy(true);
    try {
      await request('/api/game-match/lock-pair', { method: 'POST', body: JSON.stringify({ groupId: Number(groupId), userA: Number(playerA.user_id), userB: Number(playerB.user_id) }) });
      setPlayerA(null); setPlayerB(null); await load();
    } catch (lockError) { setError(lockError.message); }
    finally { setBusy(false); }
  };
  const removePair = async pair => {
    if (busy) return;
    setBusy(true);
    try {
      await request('/api/game-match/lock-pair', { method: 'DELETE', body: JSON.stringify({ groupId: Number(groupId), userA: Number(pair.user_a), userB: Number(pair.user_b) }) });
      await load();
    } catch (removeError) { setError(removeError.message); }
    finally { setBusy(false); }
  };

  const lockedIds = pairs.flatMap(pair => [Number(pair.user_a), Number(pair.user_b)]);
  const selectablePlayers = players.filter(player => !lockedIds.includes(Number(player.user_id)));

  return <div className="locked-pairs-backdrop" role="presentation" onMouseDown={event=>{if(event.target===event.currentTarget)onClose();}}><section className="locked-pairs-modal" role="dialog" aria-modal="true" aria-label="Locked Pairs"><header><strong>🔒 Locked Pairs</strong><button type="button" onClick={onClose}>✕ ปิด</button></header>{error&&<p className="locked-pairs-error">⚠️ {error}</p>}<div className="locked-pairs-list">{pairs.length===0?<p>ยังไม่มีคู่ล็อก</p>:pairs.map(pair=><article key={`${pair.user_a}-${pair.user_b}`}><span>{pair.name_a} <b>+</b> {pair.name_b}</span><button type="button" disabled={busy} onClick={()=>removePair(pair)}>ลบ</button></article>)}</div><footer><PlayerSearchDropdown value={playerA} allPlayers={selectablePlayers} usedIds={[playerB?.user_id].filter(Boolean)} onChange={setPlayerA}/><PlayerSearchDropdown value={playerB} allPlayers={selectablePlayers} usedIds={[playerA?.user_id].filter(Boolean)} onChange={setPlayerB}/><button type="button" disabled={!playerA||!playerB||busy} onClick={lockPair}>{busy?'กำลังบันทึก…':'🔒 Lock'}</button></footer></section></div>;
}

export default LockedPairsModal;
